export default "__VITE_ASSET__DfqGNTUA__"